///
/// EarthBrowser
///
/// Created by Matt Giger on 9/24/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Decoded ground-overlay images, keyed by dataset window id. The image
/// file handler decodes (and downsamples) the dropped picture, parks the
/// bitmap here, then opens the window; GroundOverlayActivity picks the
/// bitmap up to create the GPU texture. Session-lifetime, like
/// DataProviderRegistry / datasetSourceFiles.
///

export interface GroundOverlayImage {
	bitmap: ImageBitmap
	/** Pre-downsample dimensions (shown in the properties panel) */
	naturalWidth: number
	naturalHeight: number
}

const images = new Map<string, GroundOverlayImage>()

export function registerGroundOverlayImage(windowId: string, image: GroundOverlayImage): void {
	images.set(windowId, image)
}

export function getGroundOverlayImage(windowId: string): GroundOverlayImage | undefined {
	return images.get(windowId)
}

export function removeGroundOverlayImage(windowId: string): void {
	const image = images.get(windowId)
	if (image) {
		image.bitmap.close()
		images.delete(windowId)
	}
}
